export default "__VITE_ASSET__BQTHj_Ra__"